import { React, useState, useEffect } from 'react';
import { Stack, Card, Table } from 'react-bootstrap';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';

export function MobileDeviceSelector({ equipmentData, setNewPhoneNumber, setShowDetails }) {
    const { t } = useTranslation();
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [residentDevices, setResidentDevices] = useState([]);

    useEffect(() => {
        const fetchDwellingMobileDevices = async () => {
            const response = await api.getResidentMobileDevices(equipmentData.equipmentIdent);
            console.log(response);
            if (response.status === 200) {
                const devices = response.data;
                setResidentDevices(devices);
                if (devices.length === 1) {
                    handleSelectDevice(devices[0], 0);
                }
            } else {
                console.log('FAILED RECOVERING RESIDENT DEVICES');
            }
        };

        fetchDwellingMobileDevices();

    }, [])

    const handleSelectDevice = (device, index) => {
        setSelectedIndex(index);
        setNewPhoneNumber(device.phone);
        setShowDetails(true);
    };

    return (
        <Card className="SelectMobileDevice mt-3 p-4">
            <Card.Title className="mb-3">{t('md.SelectMobileDevice')}</Card.Title>
            <Stack direction="horizontal" className="justify-content-between mb-4" gap={3}>
                {residentDevices.length > 0 ? (
                    <Table size="sm" className='mb-0 mt-2'>
                        <thead>
                            <tr style={{ fontSize: '13px' }}>
                                <th>{t('md.ResidentName')}</th>
                                <th>{t('md.Model')}</th>
                                <th>{t('md.Phone')}</th>
                                <th>{t('md.Imei')}</th>

                            </tr>
                        </thead>
                        <tbody>
                            {residentDevices.map((device, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        fontSize: '13px', fontWeight: 'normal',
                                        border: selectedIndex === index ? '2px solid #007BFF' : 'none',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleSelectDevice(device, index)}>
                                    <td>{device.residentName}</td>
                                    <td style={{ color: 'gray' }}>{device.model}</td>
                                    <td style={{ color: 'gray' }}>{device.phone}</td>
                                    <td style={{ color: 'gray' }}>{device.imei}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (<p>{t('eListNoData')}</p>)}
            </Stack>
        </Card>
    );
}
